/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { IERC1822Proxiable__factory } from "./IERC1822Proxiable__factory";
